import { apiRequest } from "../index";

export const getAllHotels = async ({ page = 1, limit = 10 }) => {
  return apiRequest(`/api/admin/hotel?page=${page}&limit=${limit}`, "GET");
};

export const getHotelById = async (hotelId) => {
  return apiRequest(`/api/admin/hotel/${hotelId}`, "GET");
};

export const updateHotelStatus = async (hotelId, data) => {
  return apiRequest(`/api/admin/hotel/status/${hotelId}`, "PUT", data);
};

export const updateHotelPlatformFee = async (hotelId, data) => {
  return apiRequest(`/api/admin/hotel/platform-fee/${hotelId}`, "PUT", data);
};